// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SettingsPreview } from './SettingsPreview';

export const AppRewardsConfigurationsPreview: React.FC = () => {
  const nav = useNavigate();
  const go = () => {
    nav('app-reward-configs', { state: { pageName: 'App Reward Configurations' } });
  };
  return (
    <SettingsPreview
      enableBodyClick
      title="App Reward Configurations"
      desc="View and modify app reward configurations"
      onClick={go}
    />
  );
};
